module.exports = __webpack_public_path__ + "static/szenario3_2-7a42f8b5b5f9a2a790c12de75848ba17.png";